import { render, staticRenderFns } from "./edit-summary.vue?vue&type=template&id=44517f2b&"
import script from "./edit-summary.vue?vue&type=script&lang=js&"
export * from "./edit-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports